// @flow
import React from 'react';
import classnames from 'classnames';

import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import { Icon } from 'Components/frameworks/icon/Icon.jsx';

import { themes } from './ArrowButton.themes';

type Props = {
  className?: string,
  color?: Colors,
  colorBg?: Colors,
  hasNoRtl?: boolean,
  isDisabled?: boolean,
  label?: string,
  onClick: () => void,
  onMouseDown?: () => void,
  onMouseUp?: () => void,
  rotation?: number,
  size?: number,
  theme?: string,
  title?: string,
  trackingData?: TrackingData,
};

export function ArrowButton(props: Props) {
  const {
    className,
    color,
    colorBg,
    hasNoRtl,
    isDisabled,
    label,
    onClick,
    onMouseDown,
    onMouseUp,
    rotation = 0,
    size = 28,
    theme = 'default',
    title,
    trackingData,
  } = props;

  const { thIconName, thLabel, thRoot } = themes[theme]({ color, colorBg, isDisabled });

  const style = { height: size, width: size };

  return (
    <TrackClick
      aria-disabled={isDisabled}
      as="button"
      className={classnames(className, thRoot)}
      onClick={onClick}
      onMouseDown={onMouseDown}
      onMouseUp={onMouseUp}
      style={style}
      title={title}
      trackingData={trackingData}
      type="button"
    >
      <Icon hasRtl={!hasNoRtl} name={thIconName} rotation={rotation} width="1em" />
      {label && <span className={thLabel}>{label}</span>}
    </TrackClick>
  );
}
